import "core-js/modules/es.array.concat";
import React from 'react';
import Block from '../../../block/Block';
import CmsContent from '../../CmsContent';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import styles from './JumpCta.less';

var TitleAndCta = function TitleAndCta(_ref) {
  var title = _ref.title,
      cta = _ref.cta,
      buttoncolor = _ref.buttoncolor,
      device = _ref.device;
  return title || cta ? /*#__PURE__*/React.createElement(Block, {
    p: 's',
    layout: true,
    vertical: device.isMobile(),
    center: true,
    className: "".concat(styles['cta-border'])
  }, title && /*#__PURE__*/React.createElement("div", {
    className: getClasses({
      styles: styles,
      classes: ['cta-title'],
      device: device
    })
  }, /*#__PURE__*/React.createElement(CmsContent, {
    "data-en": 'cms-jump-cta-title',
    content: title
  })), cta && /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles['cta-button'], " ").concat(styles[buttoncolor], " ").concat(buttoncolor)
  }, /*#__PURE__*/React.createElement(CmsContent, {
    "data-en": 'cms-jump-cta-cta',
    content: cta
  }))) : null;
};

export default TitleAndCta;